import { Box, Typography } from "@mui/material";

const InputContainer = ({ title, icon, children, sx, Icon, style }) => {
  return (
    <Box
      sx={{
        width: 1,
        border: "1px solid #CFD0D2",
        borderRadius: "10px",
        backgroundColor: "background.default",
        display: "flex",
        alignItems: "flex-start",
        py: 1,
        px: 2,
        ...sx,
      }}
    >
      {Icon && (
        <Box
          sx={{
            borderRadius: "50%",
            height: "32px",
            width: "32px",
            minWidth: "32px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: "primary.chatBack",
          }}
        >
          {Icon}
        </Box>
      )}
      <Box sx={{ mt: 0.8 }}>
        {icon && <img src={icon} alt="" style={{ ...style }} />}
      </Box>
      <Box sx={{ width: 1, ml: 1, mt: 0.5 }}>
        <Typography variant="body2" sx={{ textTransform: "capitalize" }}>
          {title}
        </Typography>
        {children}
      </Box>
    </Box>
  );
};

export default InputContainer;
